'use strict';

const isRange = (value) => !!value && typeof value !== 'number' && typeof value === 'object';

exports.isRange = isRange;
//# sourceMappingURL=isRange.js.map
